import { Component, Input, EventEmitter } from '@angular/core';

import { TmpI18NService } from 'app/i18n/tmp-i18n.service';
import { BannerKeys } from 'app/shared/model/banner-keys.enum';
import { BannerMetadata } from 'app/shared/model/banner-metadata.model';
import { FieldWeb } from 'app/shared/model/item.model';

import { SettingsActionFieldNames } from './template-field-settings/settings-action-field-names.enum';
import { IFieldSettingsAction } from './template-field-settings/template-field-settings.component';

export type FieldActionsType = 'clone' | 'delete';

export interface IFieldActionsConfig {
  isVisible: boolean;
  onUpdate: EventEmitter<any>;
}

@Component({
  selector: 'cc-template-field-actions',
  templateUrl: './template-field-actions.component.html',
  styleUrls: ['./template-field-actions.component.scss'],
})
export class TemplateFieldActionsComponent {
  requiredBannerKey = BannerKeys.RequiredFieldInFieldSettings;
  requiredBannerStorageKey = BannerMetadata[this.requiredBannerKey].localStorageKey;
  requiredBannerText: string;
  hasRequiredField: boolean;

  @Input() field: FieldWeb;

  @Input() fieldActionsConfig: Record<FieldActionsType, IFieldActionsConfig>;

  @Input() fieldSettingsActions: IFieldSettingsAction[];

  @Input() disabled: boolean;

  constructor(private i18nService: TmpI18NService) {}

  ngOnInit() {
    this.requiredBannerText = this.i18nService.getMessage('requiredSettingsBanner');

    this.hasRequiredField = this.fieldSettingsActions.some(
      (action) => action.fieldName === SettingsActionFieldNames.IsRequired && action.isVisible,
    );
  }
}
